export default __webpack_public_path__ + "static/media/cafgu.467e4f0a.svg";